import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h3`
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 800;
  color: #0f172a; /* slate-900 */
`;
